import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../crbt/crbtuicss';

export interface FeaturedCategoryCSSStyle extends CRBTUICSSStyle
{
  
}

export class  FeaturedCategoryCSSStyleImpl extends CRBTUICSSStyleImpl implements FeaturedCategoryCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            width:"100%",
            height:'100%',
            display:'flex',
            marginTop: "0px",
            justifyContents: "center",
            flexDirection: "row",
            flexFlow: "row wrap"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/featuredcategorycss.tsx